var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "#304D70",
    "aria-hidden": "true",
    focusable: "false",
    className: "rs-icon",
    "aria-label": "doc pass",
    "data-category": "file",
    style: {
      color: "#4CB748"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3.5a.5.5 0 0 1 0 1H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v2.5a.5.5 0 0 1-1 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1M4.5 9h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1M4.5 3h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5A4.5 4.5 0 1 1 10.5 7a.5.5 0 0 1 0 1 3.5 3.5 0 1 0 3.5 3.5.5.5 0 0 1 1 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.854 7.146a.5.5 0 0 1 0 .707l-5 5a.5.5 0 0 1-.227.13l-.084.014h-.085a.5.5 0 0 1-.311-.145l-2-2a.5.5 0 0 1 .707-.707l1.646 1.647 4.646-4.647a.5.5 0 0 1 .707 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocVerification);
export default __webpack_public_path__ + "static/media/docVerification.724759b0ae482cec1baf84dcfae3576b.svg";
export { ForwardRef as ReactComponent };